import { grey } from '@mui/material/colors';

export const colors = {
  background: {
    default: '#FFFFFF',
  },
  primary: {
    light: '#E8EEF5',
    main: '#165297',
    dark: '#124279',
    contrastText: '#ffffff',
    900: '#09213c',
    800: '#0d315b',
    700: '#124279', // dark
    600: '#144A88',
    500: '#165297', // main
    400: '#7397C1',
    300: '#D0DCEA',
    200: '#E8EEF5', // light
    100: '#F3F6FA',
    50: '#FFFFFF',
  },
  secondary: {
    light: '#FCE9CD',
    main: '#F09103',
    dark: '#C07402',
    contrastText: '#ffffff',
    900: '#603A01',
    800: '#905702',
    700: '#C07402', // dark
    600: '#D88303',
    500: '#F09103', // main
    400: '#F3A735',
    300: '#F9D39A',
    200: '#FCE9CD', // light
    100: '#FEF4E6',
    50: '#FFFFFF',
  },
  tertiary: {
    light: '#E8EEF5',
    main: '#165297',
    dark: '#124279',
    contrastText: '#ffffff',
    900: '#09213c',
    800: '#0d315b',
    700: '#124279', // dark
    600: '#144A88',
    500: '#165297', // main
    400: '#7397C1',
    300: '#D0DCEA',
    200: '#E8EEF5', // light
    100: '#F3F6FA',
    50: '#FFFFFF',
  },
  error: {
    light: '#D03E38',
    main: '#C50E07',
    dark: '#890904',
  },
  success: {
    light: '#5BB100',
    main: '#339E33',
    dark: '#236E23',
  },
  warning: {
    light: '#FFB74D',
    main: '#FF9800',
    dark: '#F57C00',
  },
  text: {
    primary: '#4a5a5a',
    secondary: '#2D3748',
  },
  grey,
  input: {
    background: '#718096',
  },
};
